/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { Store } from "redux";

import { UserGuideActions } from "~/features/userGuide/slice";
import { getComplianceStatusAsync, getHasPaymethodAsync } from "~/features/userGuide/thunks";
import getPayoutInfoStatus from "~/features/userGuide/utils/getPayoutInfoStatus";
import { AppDispatch, RootState } from "~/state/types";
import reportError from "~/utils/reportError";

export const createUserGuideLoginSubscriber = (store: Store<RootState>) => {
  let currentUserId: string | number | null = null;

  return () => {
    const prev = currentUserId;
    currentUserId = store.getState().auth.account?.resellerId ?? null;

    if (!!currentUserId && currentUserId !== prev) {
      const dispatch: AppDispatch = store.dispatch;
      dispatch(getComplianceStatusAsync()).catch(reportError);

      const account = store.getState().auth.account;

      if (account) {
        const payoutInfoStatus = getPayoutInfoStatus(account);

        dispatch(UserGuideActions.setPayoutInfoStatus(payoutInfoStatus));
        dispatch(getHasPaymethodAsync()).catch(reportError);
      }
    }
  };
};
